var _defs, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricehomebathroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2.9051mm",
    height: "2.5135mm",
    viewBox: "0 0 10.98 9.5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: #1d1d1b;\n      }"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "5.49 9 5.7 8.88 0.87 0.5 10.11 0.5 5.27 8.88 5.49 9 5.7 8.88 5.49 9 5.7 9.13 10.98 0 0 0 5.49 9.5 5.7 9.13"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricehomebathroom);
export default __webpack_public_path__ + "static/media/pricehomebathroom.f6e8f048462ca90b8b0841e96cb0350c.svg";
export { ForwardRef as ReactComponent };